import React from 'react';
import { APP_CONFIG } from '../../../utils/constants';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="container-custom py-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-sm text-gray-600">
            © {currentYear} <span className="font-semibold text-primary-600">{APP_CONFIG.NAME}</span>. Todos os direitos reservados.
          </div>

          <div className="flex items-center gap-6 text-sm">
            <a href="/termos" className="text-gray-600 hover:text-primary-600 transition-colors">
              Termos de Uso
            </a>
            <a href="/privacidade" className="text-gray-600 hover:text-primary-600 transition-colors">
              Privacidade
            </a>
            <a href="/suporte" className="text-gray-600 hover:text-primary-600 transition-colors">
              Suporte
            </a>
          </div>

          <div className="text-sm text-gray-500">
            v{APP_CONFIG.VERSION}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;